import { memoize } from 'lodash';

export const getSelectedAuthS3Ids = memoize(selectedAuthS3Prefix => {
  const [organizationId, teamId, brandId] = selectedAuthS3Prefix ? selectedAuthS3Prefix.split('/') : [];

  return { organizationId, teamId, brandId };
});
